var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:{
    'form-radio': true,
    disabled: this.disabled,
    checked: this.checked,
    focused: _vm.focused
  }},[_c('input',{ref:"radio",attrs:{"type":"radio","disabled":_vm.disabled,"name":_vm.name},domProps:{"checked":_vm.checked,"value":_vm.val},on:{"change":function($event){return _vm.$emit('change', _vm.val, $event)},"blur":function($event){_vm.focused = false},"focus":function($event){_vm.focused = true}}}),_c('i'),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }